// extracted by mini-css-extract-plugin
module.exports = {"homeCourseContainer":"bplwuiB","homeCourseListItem":"sx7iD3O"};